import { getAuth, signInWithPopup, OAuthProvider, getAdditionalUserInfo } from "firebase/auth";
import { showNotification } from "../../redux/slices/notificationSlice";
import { OauthSignInFucntion } from "../../assets/interfaces/interfaces";
import { v4 as uuidv4 } from "uuid";
import { closeAuthModal } from "../../redux/slices/userSlice";
import { logClickEvent } from "../../analytics";

export const signInWithApple: OauthSignInFucntion = async (closeModal, dispatch, navigate) => {
  try {
    const auth = getAuth();
    const provider = new OAuthProvider("apple.com");
    const result = await signInWithPopup(auth, provider);
    // Apple does not provide a credential in the same way, so this part differs from Google
    const user = result.user;
    // Check if this is a new user and log signup event
    const additionalUserInfo = getAdditionalUserInfo(result);
    const isNewUser = additionalUserInfo?.isNewUser;

    // Create or update the Firestore document for the user
    if (navigate) {
      const newSessionId = uuidv4();
      navigate(`/chat/${newSessionId}`);
    }

    if (isNewUser) {
      // Log successful signup event for new users
      logClickEvent("sign_up", { method: "apple" });
    }

    dispatch(showNotification({ message: "Sign In Successful with Apple!", severity: "success", horizontal: "right" }));
    closeModal();
    dispatch(closeAuthModal());
    return { user }; // Token is typically not used with Apple like it is with Google
  }
  catch (error) {
    console.log(error, "error in sighn in with apple");
    dispatch(showNotification({ message: error.message, severity: "error", horizontal: "right" }));
    return { errorCode: error.code, errorMessage: error.message, email: error.email };
  }
};
